<div class="row" style="margin-left: 0px;margin-right: 0px;">


    <div class="col-md-12">
      <h4 class="title">Bounce Details</h4>

      <div class="card-box">
        <div class="row" style="padding: 0px 0px 23px 10px;">
          <div class="col-md-4">
            <h5 class="form-lable">Cheque No.:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">Cheque Date:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">Presentation Date:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">Return Date:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">Amount:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">Bank Name:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">Reason:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">Allocation Unit Code:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <!-- <div class="col-md-12 mt-20">
                <button type="button" class="btn btn-primary">Add</button>
           </div> -->
      
        </div>
      </div>
    </div>
    <div class="col-md-5">
        <h5 class="form-lable">Loan Number: <span>1234568908765432</span></h5>
    </div>
    <div class="col-md-5">
        <h5 class="form-lable">Customer Name: <span>Mohammed Imthiyas</span></h5>
    </div>
    <div class="doc-table">
      <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="false" [rows]="5"
        [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['type']">
    
        <ng-template pTemplate="header">
          <tr style="text-align: center;">
            <th>Cheque No.</th>
            <th>Cheque Date </th>
            <th>Presentation Date</th>
            <th>Return Date</th>
            <th>Amount</th>
            <th>Bank Name</th>
            <th>Reason</th>
            <th>Allocation Unit
                Code </th>
          </tr>
          <tr style="text-align: center;">
            <td>  </td>
            <td>  </td>
            <td>  </td>
            <td>  </td>
            <td>  </td>
            <td>  </td>
            <td>  </td>
            <td>  </td>
          </tr>
        </ng-template>
       </p-table>  </div>
    </div>
    <br>
    </div>